import "./hideFocus.css";

import { ReactNode } from "react";

const WebHideFocusWrapper = ({ children }: { children?: ReactNode }) => {
	return <div className="hidden-focus">{children}</div>;
};
export default WebHideFocusWrapper;
